<template>
  <keep-alive>
    <div class="main-content">
      <KegList></KegList>
    </div>
  </keep-alive>
</template>

<script>
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
import KegList from "./KegList.vue";


export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'KegIndex',
  data() {
    return {
    };
  },
  components: {
    KegList,
  },
  computed: {

  },
  async mounted() {
  },
  beforeDestroy() {
  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
</style>